<div *ngIf="vehicle" class="w-[240px] max-w-[240px] rounded-xl bg-white dark:bg-[#0e1726] text-[#0e1726] dark:text-white p-3 space-y-2.5">
  <!-- Header: plate + status pill -->
  <div class="flex items-center justify-between gap-2">
    <div class="text-base font-bold tracking-wide">{{ vehicle.plate ? (vehicle.plate | uppercase) : '—' }}</div>
    <span
      class="inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-semibold"
      [style.color]="meta?.hex"
      [style.backgroundColor]="(meta?.hex || '#000') + '1f'"
    >
      <span class="h-1.5 w-1.5 rounded-full" [style.backgroundColor]="meta?.hex"></span>
      {{ meta?.label }}
    </span>
  </div>

  <!-- Brand + model -->
  <div class="text-xs text-gray-500 dark:text-white/70">{{ vehicle.brand }} {{ vehicle.vehicle_model }}</div>

  <!-- Speed -->
  <div class="flex items-center gap-2">
    <svg class="h-5 w-5 shrink-0" viewBox="0 0 24 24" fill="none" [attr.stroke]="meta?.hex" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
      <path d="M12 12 8.5 8.5" />
      <path d="M3.5 18a9 9 0 1 1 17 0" />
    </svg>
    <div>
      <span class="text-lg font-bold leading-none">{{ vehicle.telemetry.speedKmh }}</span>
      <span class="text-[11px] text-gray-400 dark:text-white/50"> km/h</span>
    </div>
  </div>

  <!-- Driver -->
  <div class="flex items-center gap-2 text-xs">
    <svg class="h-4 w-4 text-gray-400 dark:text-white/50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
      <path d="M4 20a8 8 0 0 1 16 0" />
    </svg>
    <span class="truncate">{{ vehicle.driver.name }}</span>
  </div>

  <!-- Address -->
  <div class="flex items-start gap-2 text-xs">
    <svg class="h-4 w-4 shrink-0 text-gray-400 dark:text-white/50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 21s-6-5.2-6-10a6 6 0 0 1 12 0c0 4.8-6 10-6 10Z" />
      <circle cx="12" cy="11" r="2" />
    </svg>
    <span class="text-gray-500 dark:text-white/70">{{ vehicle.addressLabel }}</span>
  </div>

  <!-- Fuel bar -->
  <div class="space-y-1">
    <div class="flex items-center justify-between text-[10px] text-gray-400 dark:text-white/50">
      <span class="flex items-center gap-1">
        <svg class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 20V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v15" />
          <path d="M3 20h13" />
          <path d="M14 8h3l2 2v6a2 2 0 0 1-4 0v-4" />
        </svg>
        Combustible
      </span>
      <span class="font-semibold text-gray-600 dark:text-white/70">{{ vehicle.telemetry.fuelPct }}%</span>
    </div>
    <div class="h-1.5 w-full rounded-full bg-gray-200 dark:bg-white/10 overflow-hidden">
      <div
        class="h-full rounded-full transition-all"
        [style.width.%]="vehicle.telemetry.fuelPct"
        [style.backgroundColor]="vehicle.telemetry.fuelPct < 20 ? '#ef4444' : vehicle.telemetry.fuelPct < 45 ? '#f59e0b' : '#10b981'"
      ></div>
    </div>
  </div>
</div>
